module.exports = __webpack_public_path__ + "static/media/sunlover.620148ca.png";